<template>
  <div class="pagoda-form-table-layout">
    <slot name="before-form"></slot>
    <div
      v-if="hasForm || hasSlotForm"
      class="form-area"
      :style="{
        paddingBottom: !!surplusNums ? 0 : `${formItemMarginBottom}px`
      }"
    >
      <slot
        name="form"
        :btnPosition="rowsBtnsAttr"
        :formAreaRow="formAreaRow"
      >
        <pagoda-advanced-search
          :value="value"
          :form-options="formOptions"
          :label-width="labelWidth"
          :advanced-search.sync="advancedSearchVisible"
          @input="$emit('input', arguments[0])"
          v-bind="$attrs"
          ref="advancedSearch"
          inline
        >
          <pagoda-row-btns
            :style="rowsBtnsAttr.style"
            class="pagoda-form-table-layout__rows-btns"
            :btns="rowBtns"
            :visibles="btnVisibles"
          >
            <template slot="collapse">
              <el-button
                v-show="collapse"
                style="margin-left: 12px;"
                type="text"
                :disabled="disabled"
                @click="handleCollapse"
              >
                {{collapseText}}
                <i :class="[collapseIcon]"></i>
              </el-button>
            </template>
            <template slot="advancedSearch">
              <el-button
                style="margin-left: 12px;"
                type="text"
                :disabled="disabled"
                @click="advancedSearchVisible = true"
              >
                更多条件
                <i class="el-icon-caret-bottom"></i>
              </el-button>
            </template>
          </pagoda-row-btns>
          <template
            :slot="option.key"
            v-for="option in formOptions"
          >
            <slot :name="option.key"></slot>
          </template>
          <template
            slot-scope="scope"
            :slot="$scopedSlots[option.key] ? option.key : null"
            v-for="option in formOptions"
          >
            <slot
              :name="option.key"
              v-bind="scope"
            ></slot>
          </template>
          <template
            slot-scope="scope"
            :slot="`${slotKey}__${slotName}`"
            v-for="{slotKey, slotName} in getHasNameSlot"
          >
            <slot
              :name="`${slotKey}__${slotName}`"
              v-bind="scope"
            ></slot>
          </template>
        </pagoda-advanced-search>
      </slot>
    </div>
    <slot name="after-form"></slot>
    <div
      class="table-area"
      :style="{paddingTop: $slots['table-btns'] && hasForm ? '4px' : 0}"
    >
      <slot name="table-btns"></slot>
      <div
        class="before-table-area"
        v-if="$slots['before-table']"
        ref="beforeTable"
      >
        <slot name="before-table"></slot>
      </div>
      <div
        class="table-wrapper"
        :style="{marginTop: (hasForm || $slots['table-btns']) && !$slots['before-table'] ? ($slots['table-btns'] ? '12px' : '4px') : 0}"
      >
        <slot
          name="table"
          :height="tableHeight"
        ></slot>
        <slot name="pagination"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { isNumber, getEmptyArray, bounce, deepCopy } from '../../utils'

import { methodsProxy } from '../../utils'

import { addResizeListener, removeResizeListener } from 'element-ui/lib/utils/resize-event'

import advancedSearch from '../form/advanced-search'
import rowsBtns from '../button/row-btns'
import $pagoda from '../../utils/global'

const METHODS_PROXY_MAP = ['getFormRefs']

const DEFAULT_LINES = 1

export default {
  name: 'FormTableLayout',
  inheritAttrs: false,
  components: {
    'pagoda-advanced-search': advancedSearch,
    'pagoda-row-btns': rowsBtns
  },
  props: {
    value: null,
    formOptions: {
      type: Array,
      default: getEmptyArray
    },
    labelWidth: String,
    disabled: {
      type: Boolean,
      default: false
    },
    collapse: {
      type: [Boolean, Object],
      default: false
    },
    formCollapse: Boolean,
    defaultCollapse: Boolean
  },
  computed: {
    hasForm () {
      return this.formOptions.length
    },
    hasSlotForm () {
      return this.$scopedSlots.form
    },
    btnVisibles () {
      // const permission = this.$route.meta.permission
      let btnVisibles = ['search', 'reset']
      // let btnVisibles = []

      if (this.formOptions.find(({ advancedSearch }) => advancedSearch) && !this.collapse) {
        btnVisibles.push('advancedSearch')
      }

      if (this.collapse) {
        btnVisibles.push('collapse')
      }

      // if (permission.find(({code}) => code === 'search')) {
      //   btnVisibles.push('search')
      // }
      //
      // if (permission.find(({code}) => code === 'reset')) {
      //   btnVisibles.push('reset')
      // }

      return btnVisibles
    },
    getHasNameSlot () {
      let result = []

      for (const [name, slot] of Object.entries(this.$scopedSlots)) {
        const [slotKey, slotName] = name.split('__')

        if (slotName && this.formOptions.find(({ key }) => key === slotKey)) {
          result.push({
            slotKey,
            slotName
          })
        }
      }

      return result
    },
    collapseLines () {
      return isNumber(this.collapse.lines) && this.collapse.lines >= 1
        ? this.collapse.lines
        : DEFAULT_LINES
    },
    collapseText () {
      return this.isCollapse ? '查看更多' : '收起'
    },
    collapseIcon () {
      return this.isCollapse ? 'el-icon-caret-bottom' : 'el-icon-caret-top'
    },
    visibleFormOptions () {
      return this.formOptions.filter(item => !item.advancedSearch && !(item.visible === false))
    }
  },
  watch: {
    disabled: {
      immediate: true,
      handler (val) {
        this.rowBtns.reset.props.disabled = this.rowBtns.search.props.disabled = val
      }
    },
    formOptions: {
      immediate: true,
      deep: true,
      handler () {
        this.formOptions.forEach(item => {
          if (!('visible' in item)) {
            this.$set(item, 'visible', true)
          }
          if (!('visibleContro' in item)) {
            this.$set(item, 'visibleContro', !this.isCollapse)
          }
        })
      }
    },
    formCollapse () {
      this.doLayout()
    }
  },
  data () {
    return {
      surplusNums: 0,
      formAreaRow: 99,
      isCollapse: false,
      onlyOneRow: false,
      tableHeight: 0,
      advancedSearchVisible: false,
      rowsBtnsAttr: {
        style: {
          marginLeft: 0
        }
      },
      rowBtns: {
        reset: {
          props: {
            disabled: this.disabled
          },
          text: '重置',
          onClick: () => {
            this.$refs.advancedSearch.reset()
            this.$emit('reset')
          }
        },
        search: {
          text: '查询',
          props: {
            disabled: this.disabled
          },
          onClick: () => this.$emit('submit')
        },
        advancedSearch: {
          slot: 'advancedSearch'
        },
        collapse: {
          slot: 'collapse'
        }
      },
      resizeState: {
        width: null,
        height: null
      }
    }
  },
  created () {
    this.formAreaBottomSpace = 30
    this.formItemMarginBottom =
      {
        small: 18,
        mini: 18
      }[this.$ELEMENT.size] || 22
  },
  mounted () {
    this.$ready = true

    if (this.hasForm) {
      methodsProxy(this, this.$refs.advancedSearch, METHODS_PROXY_MAP)
    }

    this.resizeState = {
      width: this.$el.offsetWidth,
      height: this.$el.offsetHeight
    }

    addResizeListener(this.$el, this.resizeListener)
    this.doLayout(true)
  },
  methods: {
    resizeListener () {
      if (!this.$ready) return
      let shouldUpdateLayout = false
      const el = this.$el
      const { width: oldWidth, height: oldHeight } = this.resizeState

      const width = el.offsetWidth
      if (oldWidth !== width) {
        shouldUpdateLayout = true
      }

      const height = el.offsetHeight
      if (oldHeight !== height) {
        shouldUpdateLayout = true
      }

      if (shouldUpdateLayout) {
        this.resizeState.width = width
        this.resizeState.height = height
        this.doLayout()
      }
    },
    mapFormOptions (formRowItemNums, cb) {
      // 总共行数
      let visibleLines = 0
      let rowPointer = 0
      let visibleRowPointer = 0
      let currentRow = 0

      this.visibleFormOptions.forEach(item => {
        if (rowPointer === 0) {
          currentRow++
          if (item.visibleContro) {
            visibleLines++
          }
        }

        if (formRowItemNums === 1) {
          rowPointer = 1
        } else if (item.rowspan && item.rowspan + rowPointer > formRowItemNums) {
          currentRow += 1
          rowPointer = item.rowspan
          if (item.visibleContro) {
            visibleLines++
            visibleRowPointer = item.rowspan
          }
        } else if (item.rowspan && item.rowspan) {
          rowPointer += item.rowspan
          if (item.visibleContro) {
            visibleRowPointer += item.rowspan
          }
        } else {
          rowPointer++
          if (item.visibleContro) {
            visibleRowPointer++
          }
        }

        cb && cb(item, currentRow)

        if (rowPointer === formRowItemNums) {
          rowPointer = 0
        }

        if (visibleRowPointer === formRowItemNums) {
          visibleRowPointer = 0
        }
      })

      return {
        visibleLines,
        currentRow,
        rowPointer,
        visibleRowPointer
      }
    },
    getWidth () {
      const wrapperEl = this.$el
      const formItemElIndex = this.formOptions.findIndex(
        item =>
          !item.advancedSearch &&
          item.visible !== false &&
          !item.rowspan &&
          item.visibleContro !== false
      )
      const formItemEl = wrapperEl.querySelectorAll('.el-form-item')[formItemElIndex]
      const labelEl = formItemEl.querySelector('.el-form-item__label')

      const formItemStyle = getComputedStyle(formItemEl)
      const formItemWidth =
        parseInt(formItemStyle.marginLeft) +
        parseInt(formItemStyle.marginRight) +
        formItemEl.offsetWidth
      const labelWidth = labelEl.clientWidth

      return {
        labelWidth,
        formItemWidth
      }
    },
    getWidthWithSlot () {
      const wrapperEl = this.$el
      const elFormItem = wrapperEl.querySelectorAll(
        '.el-form-item:not(.pagoda-form-table-layout__span2)'
      )[0]
      const formItemStyle = getComputedStyle(elFormItem)
      const formItemWidth =
        parseInt(formItemStyle.marginLeft) +
        parseInt(formItemStyle.marginRight) +
        elFormItem.offsetWidth

      const label = elFormItem.querySelector('.el-form-item__label')

      return {
        labelWidth: label ? label.offsetWidth : 0,
        formItemWidth
      }
    },
    getWrapperWidth () {
      const wrapperEl = this.$el
      const wrapperStyle = getComputedStyle(wrapperEl)
      const wrapperWidth =
        wrapperEl.clientWidth -
        parseInt(wrapperStyle.paddingLeft) -
        parseInt(wrapperStyle.paddingRight)

      return wrapperWidth
    },
    handleCollapse () {
      const wrapperWidth = this.getWrapperWidth()

      // 如果是点击了收起 则记录下当前的formRowItemNums
      if (!this.isCollapse) {
        // 一行能放几个form-item
        this.formRowItemNums = Math.floor(wrapperWidth / this.width.formItemWidth)
      }

      this.mapFormOptions(this.formRowItemNums, (item, currentRow) => {
        if (currentRow > this.collapseLines) {
          item.visibleContro = this.isCollapse
        }
      })

      this.isCollapse = !this.isCollapse
      this.doLayout()
    },
    doLayout (init) {
      const update = () => {
        if (this.hasForm) {
          this.width = this.getWidth()
          this.caculateFormConfig()

          if (init && this.collapse && this.defaultCollapse) {
            this.handleCollapse()
          }
        } else if (this.hasSlotForm) {
          this.widthWithSlot = this.getWidthWithSlot()
          this.caculateSlotFormConfig()
        }
        this.$nextTick(this.caculateTableHeight)
      }

      if (init) {
        setTimeout(update, 0)
      } else {
        this.$nextTick(update)
      }
    },
    caculateSlotFormConfig () {
      const wrapperWidth = this.getWrapperWidth()
      // 一行能放几个form-item
      const formRowItemNums = Math.floor(wrapperWidth / this.widthWithSlot.formItemWidth)

      let rowPointer = 0
      let currentRow = 0
      let visibleRowPointer = 0
      let visibleLines = 0

      Array.from(this.$el.querySelectorAll('.form-area .el-form-item')).forEach(elFormItem => {
        if (rowPointer === 0) {
          currentRow++
          if (this.formCollapse && currentRow <= 1) {
            visibleLines++
          }
        }

        const isItemVisible = this.formCollapse ? currentRow <= 1 : true
        const rowspan =
          Array.from(elFormItem.classList).includes('pagoda-form-table-layout__span2') && 2

        if (rowspan === 2) {
          elFormItem.style.width = `${this.widthWithSlot.formItemWidth * 2 - 10}px`
          elFormItem.querySelector('.el-form-item__content').style.width = `${this.widthWithSlot
            .formItemWidth *
            2 -
            10 -
            this.widthWithSlot.labelWidth}px`
        }

        if (formRowItemNums === 1) {
          rowPointer = 1
          visibleRowPointer = 1
        } else if (rowspan && rowspan + rowPointer > formRowItemNums) {
          if (isItemVisible) {
            visibleLines++
            visibleRowPointer = rowspan
          }
          currentRow++
          rowPointer = rowspan
        } else if (rowspan) {
          rowPointer += rowspan
          if (isItemVisible) {
            visibleRowPointer += rowspan
          }
        } else {
          rowPointer++
          if (isItemVisible) {
            visibleRowPointer++
          }
        }

        if (rowPointer === formRowItemNums) {
          rowPointer = 0
        }

        if (visibleRowPointer === formRowItemNums) {
          visibleRowPointer = 0
        }

        if (!isItemVisible) {
          elFormItem.style.display = 'none'
        } else {
          elFormItem.style.display = ''
        }
      })

      this.onlyOneRow = currentRow === 1
      this.surplusNums = this.formCollapse ? visibleRowPointer : rowPointer
      // 当前表单区域在当前宽度下占几行
      this.formAreaRow = rowPointer === 0 ? currentRow + 1 : currentRow

      if (rowPointer) {
        if (this.onlyOneRow) {
          this.rowsBtnsAttr.style.marginLeft = parseInt(this.widthWithSlot.labelWidth) + 'px'
        } else {
          this.rowsBtnsAttr.style.marginLeft =
            (formRowItemNums - this.surplusNums - 1) * this.widthWithSlot.formItemWidth +
            parseInt(this.widthWithSlot.labelWidth) +
            'px'
        }
      } else {
        this.rowsBtnsAttr.style.marginLeft =
          (formRowItemNums - 1) * this.widthWithSlot.formItemWidth +
          parseInt(this.widthWithSlot.labelWidth) +
          'px'
      }
    },
    caculateFormConfig () {
      const wrapperWidth = this.getWrapperWidth()
      // 一行能放几个form-item
      const formRowItemNums = Math.floor(wrapperWidth / this.width.formItemWidth)

      const { visibleLines, currentRow, rowPointer, visibleRowPointer } = this.mapFormOptions(
        formRowItemNums
      )

      this.onlyOneRow = visibleLines === 1
      this.surplusNums = this.isCollapse ? visibleRowPointer : rowPointer

      if (this.surplusNums) {
        if (this.onlyOneRow) {
          this.rowsBtnsAttr.style.marginLeft = parseInt(this.width.labelWidth) + 'px'
        } else {
          this.rowsBtnsAttr.style.marginLeft =
            (formRowItemNums - this.surplusNums - 1) * this.width.formItemWidth +
            parseInt(this.width.labelWidth) +
            'px'
        }
      } else {
        this.rowsBtnsAttr.style.marginLeft =
          (formRowItemNums - 1) * this.width.formItemWidth + parseInt(this.width.labelWidth) + 'px'
      }
    },
    caculateTableHeight () {
      const wrapperEl = this.$el
      const tableWrapperEl = wrapperEl.querySelector('.table-wrapper')
      // 给分页预留 60px 的位置
      const tableHeight = tableWrapperEl.clientHeight - 60
      let beforeTableSlotHeight = 0

      // 兼容table中配置表格按钮
      const visibleTable = Array.from(tableWrapperEl.querySelectorAll('.pagoda-table')).find(
        table => table.style.display !== 'none'
      )
      const gridBtnsWrapper = visibleTable && visibleTable.querySelector('.grid-btns-wrapper')
      const afterTableSlot = visibleTable && visibleTable.querySelector('.pagoda-table__after')
      let gridBtnsWrapperStyle,
        gridBtnsWrapperHeight = 0,
        afterTableSlotStyle,
        afterTableSlotHeight = 0

      if (gridBtnsWrapper) {
        gridBtnsWrapperStyle = getComputedStyle(gridBtnsWrapper)
        gridBtnsWrapperHeight =
          parseInt(gridBtnsWrapperStyle.marginTop) +
          gridBtnsWrapper.clientHeight +
          parseInt(gridBtnsWrapperStyle.marginBottom)
      }

      if (afterTableSlot) {
        afterTableSlotStyle = getComputedStyle(afterTableSlot)
        afterTableSlotHeight =
          parseInt(afterTableSlotStyle.marginTop) +
          afterTableSlot.clientHeight +
          parseInt(afterTableSlotStyle.marginBottom)
      }

      this.tableHeight =
        tableHeight - gridBtnsWrapperHeight - afterTableSlotHeight - beforeTableSlotHeight + 'px'
    }
  }
}
</script>
